import React from "react";
import { Link } from "react-router-dom";
function Strength() {
  return (
    <section className="amit-features py-5" id="work">
      <div className="container py-lg-5 py-md-4 py-2">
        {/* <h5 className="title-subw3hny text-center">How to Protect Yourself?</h5> */}
        <h3 className="title-ac mb-5 text-center">
          Thank You for your inquiry with us.
        </h3>
        <div className="main-cont-wthree-2 align-items-center">
          <div className="services-page  mt-4 text-center">
            <p>
              Your request has been submitted successfully! Our representative
              will get in touch with you shortly.
            </p>
            <div className="text-center">
              <Link to="/" className="btn btn-primary btn-style mt-md-5 mt-4">
                Back To Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Strength;
